export default "__VITE_ASSET__i6uR6_Ir__"